import React, { useState } from "react";
import { Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import {
    Row,
    Col,
    Form,
    Label,
    Input,
    FormFeedback,
    Button,
} from "reactstrap";

// import images
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import colorlogo from "../../assets/images/ci_logo.png";
import "assets/scss/custom/pages/_signup.scss";
import { addPartnerEnquiry } from "http/auth/signup";
import ToastDialog from "components/Common/ToastDialog";

const PartnerEnqueryForm = () => {
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [isAgree, setIsAgree] = useState(false);

    document.title = "Enquiry | FundLync";

    //form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNo: "",
            entityName: "",
            enquiry: "",
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("Please Enter Your First Name"),
            lastName: Yup.string().required("Please Enter Your Last Name"),
            email: Yup.string()
                .email("Must be a valid Email")
                .max(255)
                .required("Please Enter Your Email"),
            mobileNo: Yup.number().min(10).required("Please Enter Your Phone"),
            entityName: Yup.string().required("Please Enter Your Company Name"),
            enquiry: Yup.string().required("Please Write your query"),

        }),
        onSubmit: (values) => {
            if (isAgree) {
                submitUserEnquiryForm(values);
            } else {
                setToastInfo({
                    message: "Accept Term and Condition",
                    showToast: true,
                    role: "error",
                });
                validation.setSubmitting(false);
            }
        },
    });

    const acceptAgreement = (event) => {
        setIsAgree(event.target.checked);
    };

    const submitUserEnquiryForm = (values) => {
        const enquiryData = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobileNo: String(values.mobileNo),
            entityName: values.entityName,
            enquiry: values.enquiry
        };
        
        addPartnerEnquiry(enquiryData)
            .then((responseFromAPI) => {
                console.log(responseFromAPI,"res")
                if (responseFromAPI.code == 201 && responseFromAPI.status) {
                    setToastInfo({
                        message: responseFromAPI.message,
                        showToast: true,
                        role: "success",
                    });
                    validation.resetForm()
                } else {
                    setToastInfo({ message: responseFromAPI.message, showToast: true, role: "error" });
                }
            })
            .catch((e) => { })
            .finally((f) => {
                validation.setSubmitting(false);
            });
    };

    return (
        <React.Fragment>
            <div className="account-pages account-pages-bg bg-color login-page">
                <Row className="justify-content-center m-auto h-100vh scrollable-height" style={{width:'90%'}}>
                    <Col md={6} xl={8} lg={7} className="d-none d-md-block">
                        <div className="left-section h-100">
                            <img src={lightlogo} alt="" className="img-fluid ci-logo"  style={{ width: '200px' }}/>
                            <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                                <img
                                    src={verificationImg}
                                    alt=""
                                    className="img-fluid verification-img"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6}
                        lg={5}
                        xl={4}
                        className="form-layout-section m-auto d-flex justify-content-center ">
                        <div className="d-flex flex-column h-100 vertical-scroll">
                            <div className="p-2 mt-auto mb-auto">
                                <div className="d-flex flex-column align-items-center">
                                    <h3 className="mt-3 mb-3 header-reg">Partner Inquiry</h3>
                                </div>

                                <Form
                                    className="needs-validation"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <div className="form-floating mb-3">
                                        <Input
                                            name="firstName"
                                            placeholder="Enter User Name"
                                            type="text"
                                            className="form-control"
                                            id="firstname"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.firstName || ""}
                                            invalid={
                                                !!(validation.touched.firstName && validation.errors.firstName)
                                            }
                                            disabled={validation.isSubmitting}
                                        />
                                        <Label htmlFor="firstname">First Name *</Label>
                                        {validation.touched.firstName && validation.errors.firstName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.firstName}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                    <div className="form-floating mb-3">
                                        <Input
                                            name="lastName"
                                            placeholder="Enter User Name"
                                            type="text"
                                            className="form-control"
                                            id="lastname"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.lastName || ""}
                                            invalid={
                                                !!(validation.touched.lastName && validation.errors.lastName)
                                            }
                                            disabled={validation.isSubmitting}
                                        />
                                        <Label htmlFor="lastname">Last Name *</Label>
                                        {validation.touched.lastName && validation.errors.lastName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.lastName}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                    <div className="form-floating mb-3">
                                        <Input
                                            name="email"
                                            placeholder="Enter Valid Email"
                                            type="email"
                                            className="form-control"
                                            id="validationEmail"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={
                                                !!(validation.touched.email && validation.errors.email)
                                            }
                                            disabled={validation.isSubmitting}
                                        />
                                        <Label htmlFor="validationEmail">Email *</Label>
                                        {validation.touched.email && validation.errors.email ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.email}
                                            </FormFeedback>
                                        ) : null}
                                    </div>
                                    <div className="form-floating mb-3">
                                        <Input
                                            name="mobileNo"
                                            placeholder="Enter Contact Number"
                                            type="number"
                                            id="validationPhone"
                                            className="form-control no-spin"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.mobileNo || ""}
                                            invalid={
                                                !!(validation.touched.mobileNo && validation.errors.mobileNo)
                                            }
                                            disabled={validation.isSubmitting}
                                        />
                                        <Label htmlFor="validationPhone">Phone *</Label>
                                        {validation.touched.mobileNo && validation.errors.mobileNo ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.mobileNo}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                    <div className="form-floating mb-3">
                                        <Input
                                            name="entityName"
                                            type="text"
                                            placeholder="Enter Company Name"
                                            id="validationEntityName"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.entityName || ""}
                                            invalid={
                                                !!(
                                                    validation.touched.entityName &&
                                                    validation.errors.entityName
                                                )
                                            }
                                        />
                                        <Label htmlFor="validationEntityName">
                                            Company Name
                                        </Label>
                                        {validation.touched.entityName && validation.errors.entityName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.entityName}
                                            </FormFeedback>
                                        ) : null}
                                    </div>
                                    
                                    <div className="form-floating mb-3">
                                        <Input
                                            name="enquiry"
                                            type="textarea"
                                            placeholder="Write your enquiry"
                                            id="enquiry"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.enquiry || ""}
                                            invalid={
                                                !!(
                                                    validation.touched.enquiry &&
                                                    validation.errors.enquiry
                                                )
                                            }
                                        />
                                        <Label htmlFor="enquiry">
                                            Write your query
                                        </Label>
                                        {validation.touched.enquiry && validation.errors.enquiry ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.enquiry}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                    <div>
                                        <Col lg="12">
                                            <div className="form-check">
                                                {isAgree}
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="invalidCheck"
                                                    value={isAgree}
                                                    onChange={(event) => acceptAgreement(event)}
                                                    style={{ borderColor: "#ced4da" }}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="invalidCheck"
                                                >
                                                    {" "}
                                                    Agree to{" "}
                                                    <span
                                                        onClick={() =>
                                                            window.open(
                                                                "https://www.cashinvoice.in/legal/terms-and-conditions"
                                                            )
                                                        }
                                                        className="tandc"
                                                    >
                                                        terms and conditions
                                                    </span>
                                                </Label>
                                            </div>
                                        </Col>
                                    </div>
                                    <div className="w-100 mt-4 d-flex justify-content-center">
                                        <Button color="primary" type="submit">
                                            <output>
                                                {validation.isSubmitting && (
                                                    <span
                                                        className="spinner-border spinner-border-sm ms-2 me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                )}
                                            </output>
                                            {!validation.isSubmitting && <span>Submit</span>}
                                            {validation.isSubmitting && <span>Submiting</span>}
                                        </Button>
                                    </div>
                                </Form>
                            </div>

                            <div className="mt-0 text-center">
                                <p>
                                    Already have an account ?{" "}
                                    <Link to="/login" className="fw-medium text-primary">
                                        {" "}
                                        Login
                                    </Link>{" "}
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>
    );
};

export default PartnerEnqueryForm;
